<template>
  <div>
    <v-col cols="12" sm="12">
      <b-alert
          show
          variant="light"
          class="alert alert-custom alert-success alert-shadow fade show gutter-b mb-0"
      >
        <div class="alert-text mt-2 text-center">
          <h1 style="color: #000000"><b>Transactions</b></h1>
        </div>
      </b-alert>
    </v-col>
    <v-col cols="12" sm="12">
      <v-tabs v-model="activeTab" background-color="#002366" centered dark>
        <v-tab>Sale</v-tab>
        <v-tab>Rent</v-tab>
      </v-tabs>
      <keep-alive>
        <TransactionsTable
            v-if="activeTab === 0"
            key="sale-transactions"
            purpose="1"
        />
        <TransactionsTable
            v-else
            key="rent-transactions"
            purpose="2"
        />
      </keep-alive>
    </v-col>
  </div>
</template>

<script>
import TransactionsTable from "@/view/pages/realstate/market_insights/inc/TransactionsTable.vue";

export default {
  name: "transactions",
  components: {
    TransactionsTable
  },
  mounted() {},
  methods: {}
};
</script>
